"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Llm = void 0;
exports.Llm = {
    Gpt4OMini: "gpt-4o-mini",
    Gpt4O: "gpt-4o",
    Gpt4: "gpt-4",
    Gpt4Turbo: "gpt-4-turbo",
    Gpt35Turbo: "gpt-3.5-turbo",
    Gemini15Pro: "gemini-1.5-pro",
    Gemini15Flash: "gemini-1.5-flash",
    Gemini20FlashExp: "gemini-2.0-flash-exp",
    Gemini10Pro: "gemini-1.0-pro",
    Claude35Sonnet: "claude-3-5-sonnet",
    Claude3Haiku: "claude-3-haiku",
    GrokBeta: "grok-beta",
    CustomLlm: "custom-llm",
};
